import { Component, OnInit, inject } from '@angular/core';
import { MessageService } from '../../../main';
import { AppSettingsService, SpinnerService } from '../../../core';
import { BucketItemService } from '../service/bucket-item.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDeleteFolderPopUp } from '../models/delete-folder-popup.model';
import { IDeleteFolderRequest } from '../models/delete-folder-request.model';
import { catchError, map, throwError } from 'rxjs';
import { IBucketItem } from "../models/bucket-item.model";
import { FolderPermissionComponent } from '../../requester-access/folder-permission/folder-permission.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-delete-popup',
    templateUrl: './delete-popup.component.html',
    styleUrls: ['./delete-popup.component.scss'],
    imports: [MatButton]
})
export class DeletePopupComponent implements OnInit {
  private messageService = inject(MessageService);
  private appSettingService = inject(AppSettingsService);
  private bucketItemsService = inject(BucketItemService);
  private spinnerService = inject(SpinnerService);
  private readonly dialogRef = inject<MatDialogRef<DeletePopupComponent>>(MatDialogRef);
  data = inject<IDeleteFolderPopUp>(MAT_DIALOG_DATA);

  packagefolder: Partial<IBucketItem>[] = [];
  public header:string = "Are you sure you want to delete?";
  public message:string = "This cannot be reverted.";
  public deleteFolderRequest: IDeleteFolderRequest;

  ngOnInit(): void {
    if(!this.data){
        this.header= "Revoke package folder access";
        this.message= `Are you sure you want to revoke Package Folder access from ${FolderPermissionComponent.RequesterPuid}?`;
    }
  }



  
    /** This method is to close the pop up and to pass confirmation action */
    public deleteFolder(): void {
      if (this.data?.SelectedBucketItems.length === 1)
      {
        this.deleteFolderRequest = {
          BucketItemId : this.data.SelectedBucketItems[0].Id,
          BUCode: this.data.CurrentBreadcrumbItem.BUCode,
          BucketType: this.data.CurrentBreadcrumbItem.BucketType,
          FolderName: this.data.SelectedBucketItems[0].LeafName
        };
        this.spinnerService.show(true);
  
        this.bucketItemsService.DeleteFolder(this.deleteFolderRequest)
        .pipe(
            map((res: boolean) => {
              if (res) {
               
                  this.messageService.success(
                    "Folder successfully deleted.",
                    this.appSettingService.toastrDisplayTime
                  );
                  this.dialogRef.close(true);
  
                this.spinnerService.show(false);
              }
              else{
                this.dialogRef.close(false);
              }
            }),
            catchError((error: any) => {
              this.dialogRef.close(false);
              this.spinnerService.show(false);
              if (error.error.detail !== undefined) {
                this.messageService.alert(
                  error.error.detail,
                  this.appSettingService.toastrDisplayTime
                );
              } else {
                this.messageService.alert(
                  "Delete failed, please try again",
                  this.appSettingService.toastrDisplayTime
                );
              }
              return throwError(() => {
                new Error(error.message);
              });
            })
          )
          .subscribe();
      }
      else{
        this.dialogRef.close(true);
      }
    }
    /* #endregion */
  onCloseClick(): void {
    this.dialogRef.close(false);
  }

}
